import { Map, Record } from 'immutable';

import { convertRawValues } from '../lib/utils/record_utils';

const terminalStatuses = [
  'uplifted',
  'no_change',
  'identity_mismatch',
  'failed_soft',
  'timed_out',
  'skipped',
  'unexpected_result',
];

export default class PostApprovalPlaidAttemptRecord extends Record({
  attempt_id: null,
  status: null,
  status_url: '',
  submitted_at: null,
  deadline_at: null,
  baseline: Map(),
  effective: Map(),
  company_underwriting_enhanced: false,
  account_ready: false,
  account_mask: null,
  error_code: null,
  copy_key: null,
  can_continue: false,
  next_route_path: null,
}) {
  constructor(data) {
    super(convertRawValues(data));
  }

  get isTerminal() {
    return terminalStatuses.includes(this.status);
  }

  get isOpen() {
    return ['offered', 'link_ready'].includes(this.status);
  }

  get isProcessing() {
    return this.status === 'processing';
  }
}
